import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css';
import ElementUI from 'element-ui';     //引入element库
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import Stomp from "stompjs";
import login from '@/components/login/Login.vue';
import transferLogin from '@/components/login/TransferLogin.vue';
import yunEasy from '@/components/login/StandardSysCombination.vue';
import externalPage from '@/components/OnlineService/ExternalWebPage.vue';
import SubmitMessPage from '@/components/OnlineService/SubmitMessPage.vue';
Vue.use(Router);
Vue.use(iView);
Vue.use(ElementUI);
Vue.prototype.$echarts = echarts;
Vue.prototype.$http = axios;
Vue.prototype.Stomp = Stomp;
Vue.prototype.$video = videojs;

/*生产环境*/
let port = window.location.port;
let ip = window.location.host;
if(ip){
  ip = ip.split(":")[0];
}
let httpStyle = window.location.protocol;
/* 测试环境 */
// ip = "32046.yuneasy.cn";
// httpStyle = "https";
// port = "443";
if(httpStyle.indexOf(':') < 0){
    httpStyle = httpStyle + ":";
}
if(port!= undefined && port != ""){
  ip = ip + ":" + port;
}

Vue.prototype.baseURL = httpStyle + '//' + ip + '/mpccApi/';  //生产环境
Vue.prototype.baseImgURL = httpStyle + '//' + ip;
Vue.prototype.MQTT_SERVICE = ''; // mqtt服务地址
Vue.prototype.MQTT_USERNAME = 'admin';// mqtt连接用户名
Vue.prototype.MQTT_PASSWORD = 'YunEasy_eos';// mqtt连接密码
Vue.prototype.WEBRTC_SERVICE = ''; // webrtc注册地址
Vue.prototype.SCHEME = httpStyle;
export default new Router({
  mode: 'history',
  // mode:'hash',
  base: '/mpcc/',
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/null',
      redirect: '/login',
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{
        keepAlive:true
      }
    },
    {
      path: '/index',
      name: 'yunEasy',
      component: yunEasy,
      meta:{
        keepAlive:false
      }
    },
    {
      path: '/transferLogin',
      name: 'transferLogin',
      component: transferLogin,
      meta:{
        keepAlive:false
      }
    },
    {
      path: '/externalPage',
      name: 'externalPage',
      component: externalPage,
      meta:{
        keepAlive:false
      }
    },
    {
      path: '/SubmitMessPage',
      name: 'SubmitMessPage',
      component: SubmitMessPage,
      meta: {
        keepAlive: false
      }
    },
  ]
})
axios.defaults.headers.Accept = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
axios.defaults.baseURL = httpStyle + '//' + ip + '/mpccApi/';

Vue.prototype.registerPhone = function () {
  sipRegister();
};

Vue.prototype.initArgument = function (obj) {
  let mqInfo = obj.mqInfo;
  let webrtcInfo = obj.webrtcInfo;
  for (let i = 0; i < mqInfo.length; i++) {
    let configKey = mqInfo[i].configKey;
    let configValue = mqInfo[i].configValue;
    if (configKey == 'mq_address') {
      Vue.prototype.MQTT_SERVICE = 'ws://' + configValue + ':15674/ws'; // mqtt服务地址
      if (httpStyle.indexOf("https") != "-1") {
        Vue.prototype.MQTT_SERVICE = 'wss://' + configValue + ':15675/ws'; // mqtt服务地址
      }
    }
    if (configKey == 'mq_password') {
      Vue.prototype.MQTT_PASSWORD = configValue;
    }
    if (configKey == 'mq_user') {
      Vue.prototype.MQTT_USERNAME = configValue;
    }
  }
  for (let k = 0; k < webrtcInfo.length; k++) {
    let rtcKey = webrtcInfo[k].configKey;
    let Value = webrtcInfo[k].configValue;
    if (rtcKey == 'registered_address') {

        if(Value.split(',') > 1){

        }else{
          Value = Value.replace(',','');
        }


      Vue.prototype.WEBRTC_SERVICE = Value;
    }
  }
  initArgu(obj);
};
Vue.prototype.initLoginArgument = function (obj) {
  initLogin(obj);
};



// WEBPACK FOOTER //
// ./src/router/index.js